module.exports = __webpack_public_path__ + "e9552758807cc0cc2183d02683da9082.png";